module.exports = __webpack_public_path__ + "img/kiri_3.80ad460f.jpg";